import React from "react";
import MagazynListPage from "./MagazynListPage";
import { ARCHIWUM_ODPRAWA_CELNA } from "./magazynListConfigs";

// Archiwum Odprawa Celna (Magazyn Warszawa) - wspolny widok listy z konfiguracja tej listy.
const Dashboard = () => <MagazynListPage config={ARCHIWUM_ODPRAWA_CELNA} />;

export default Dashboard;
